import { ChangeEvent } from 'react';
import {
  TextField,
  Grid,
  InputAdornment,
  SelectChangeEvent,
  FormControlLabel,
  Checkbox,
} from '@mui/material';
import FrequencySelect from '../../components/FrequencySelect';
import { InvalidEntryFlags, ThresholdForm } from './types';

interface Props {
  threshold: ThresholdForm;
  handleThresholdChanged: (
    event:
      | SelectChangeEvent<string>
      | ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
      checked?: boolean
  ) => void;
  invalidEntryFlags: InvalidEntryFlags;
  disabled?: boolean;
}

const MonitorSettingsForm = ({
  threshold,
  handleThresholdChanged,
  invalidEntryFlags,
  disabled,
}: Props) => {
  return (
    <Grid container spacing={1} style={{ paddingTop: '5px' }}>
      <Grid item xs={12}>
        <TextField
          id='name'
          name='name'
          label='Name'
          value={threshold?.name}
          variant='outlined'
          size='small'
          onChange={handleThresholdChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='beginFrequencyValue'
          name='beginFrequencyValue'
          label='Begin'
          value={threshold?.beginFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleThresholdChanged}
          error={invalidEntryFlags.begin}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={threshold?.beginFrequencyUnit}
          name='beginFrequencyUnit'
          onChange={handleThresholdChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          id='endFrequencyValue'
          name='endFrequencyValue'
          label='End'
          value={threshold?.endFrequencyValue}
          variant='outlined'
          size='small'
          onChange={handleThresholdChanged}
          error={invalidEntryFlags.end}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={6}>
        <FrequencySelect
          selected={threshold?.endFrequencyUnit}
          name='endFrequencyUnit'
          onChange={handleThresholdChanged}
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          type='number'
          id='bound'
          name='bound'
          label='Bound'
          value={threshold?.bound}
          variant='outlined'
          size='small'
          onChange={handleThresholdChanged}
          InputProps={{
            endAdornment: <InputAdornment position='end'>dBm</InputAdornment>,
          }}
          error={invalidEntryFlags.bound}
          disabled={disabled}
        />
      </Grid>
      <Grid item container>
        <Grid item>
          <FormControlLabel
            name='warning'
            control={
              <Checkbox
                onChange={handleThresholdChanged}
                checked={!!threshold?.warning}
                name='warning'
                disabled={disabled}
              />
            }
            label='Warning Mode'
          />
        </Grid>
    </Grid>
  </Grid>
  );
};

export default MonitorSettingsForm;
